import { Input } from "@/components/ui/input";

interface QuantityInputProps {
  lossQuantity: string;
  onQuantityChange: (value: string) => void;
  maxQuantity?: number;
  label?: string;
  placeholder?: string;
}

export const QuantityInput = ({
  lossQuantity,
  onQuantityChange,
  maxQuantity,
  label = "Quantité perdue",
  placeholder = "Entrez la quantité perdue"
}: QuantityInputProps) => {
  return (
    <div className="space-y-2">
      <label
        htmlFor="quantity"
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {label}
      </label>
      <Input
        id="quantity"
        type="number"
        value={lossQuantity}
        onChange={(e) => onQuantityChange(e.target.value)}
        placeholder={placeholder}
        min="1"
        max={maxQuantity}
      />
      {maxQuantity !== undefined && (
        <p className="text-sm text-muted-foreground">
          Stock actuel: {maxQuantity}
        </p>
      )}
    </div>
  );
};